import React from 'react';

const Header= () => {
    return (
        <div className='hero'>
            <div className="heroInner">
                <h1 className='heroHeadline'>Get Glossy </h1>
                <h2 className="h2Title">Treat Yourself </h2>
                <h3 className="subtitle">30% off select lipstick products</h3>
                <p className='subtitle'>For a limited time</p>
                
            </div>
        </div>
    )
}

export default Header